import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-address',
    template: `
        @switch (country) {
            @case ('GB') {
                {{ stairway }} {{ street }}{{ floor !== null ? ', ' + floor : '' }}
            }
            @case ('FR') {
                {{ stairway }} {{ street }}{{ floor !== null ? ', ' + floor : '' }}
            }
            @default {
                {{ street }} {{ stairway }}{{ floor !== null ? ', ' + floor : '' }}
            }
        }
    `,
    styles: [
        `
            span {
                white-space: nowrap;
            }
        `,
    ],
    standalone: true,
    imports: [],
})
export class AddressComponent {
    @Input() street: string | null = null;
    @Input() stairway: string | null = null;
    @Input() floor: string | null = null;
    @Input({required: true}) country!: string;
}
